import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { LoginService } from '../../login/login.service';
import { User } from '../../models/user';

@Component({
  selector: 'app-navbar',
  templateUrl: './app-navbar.component.html',
  styleUrls: ['./app-navbar.component.css']
})
export class AppNavbarComponent implements OnInit {
  isAdmin = false;
  isLoggedIn = false;
  currentUser: User;
  @Input() title = '';
  faUser = faUser;

  constructor(private loginService: LoginService, private router: Router) { }

  ngOnInit() {
    this.isLoggedIn = this.loginService.isLoggedIn;
    this.currentUser = this.loginService.currentUser;
    this.isAdmin = this.loginService.isAdmin;
    this.loginService.isLoggedIn$.subscribe(res => {
      this.isLoggedIn = res;
      this.isAdmin = this.loginService.isAdmin;
      this.currentUser = this.loginService.currentUser;
    });
  }

  logout() {
    this.loginService.logout();
    this.router.navigate(['']);
  }

}
